import { Checkbox } from '@material-ui/core';
import { defaultProps } from 'recompose';

import ControlTile from '@/components/ControlTile';

export default defaultProps({ Control: Checkbox })(ControlTile);
export { default as CheckBoxGroup } from './CheckBoxGroup';
